// represents something that has a string id.
export interface IHasId {
  id: string;
}

export function objectHasId(object: any): object is IHasId {
  return (
    !!object && typeof object === "object" && typeof object["id"] === "string"
  );
}
